module.exports = __webpack_public_path__ + "static/media/Final_Resume.18ddf36a.pdf";